export default () => {
    const heroSlides = document.querySelectorAll('[data-hero-slide]')
    const heroNavigationDots = document.querySelectorAll('[data-slide-nav]')

    const goToSlide = (slideIndex) => {
        heroSlides.forEach((slide) => {
            delete slide.dataset.active
            document.querySelector(
                `[data-hero-slide="${slideIndex}"]`
            ).dataset.active = 'true'
            setTimeout(heroSlides, 2000)
        })

        heroNavigationDots.forEach((dot) => {
            delete dot.dataset.active
            document.querySelector(
                `[data-slide-nav="${slideIndex}"]`
            ).dataset.active = 'true'
        })
    }

    if (heroSlides) {
        Array.from(heroNavigationDots).forEach((navDot) => {
            navDot.addEventListener('click', function () {
                const targetIndex = this.dataset.slideNav
                goToSlide(targetIndex)
            })
        })
    }

    let i = 1
    setInterval(() => {
        goToSlide((i % heroSlides.length) + 1)
        i++
    }, 5000)
}
